/**
 * Fixed UI copy of the contact form (Figma „Kontakt“ 60338:23464, „Kontakt - odoslaný form“
 * 60333:28377). Labels that exist word for word in the core dictionary (Meno a priezvisko, E-mail,
 * Telefón, Číslo objednávky, Správa, Odoslať správu, Vybrať súbory) are read with `t()`; the rest has
 * no dictionary key and is not administration content.
 */
export const CONTACT_COPY = {
  title: 'Napíšte nám správu',
  requiredNote: 'Polia označené * sú povinné.',
  placeholders: {
    fullName: 'Napr. Ján Novák',
    email: 'vas@email.sk',
    phone: '+421 9XX XXX XXX',
    orderNumber: 'Napr. 2025001234',
    text: 'Opíšte, s čím vám môžeme pomôcť…',
  },
  fullNameIncomplete: 'Zadajte meno aj priezvisko.',
  orderNumberHint: 'Nepovinné – urýchli vybavenie',
  counter: (count: number, max: number) => `${count} / ${max} znakov`,
  attachments: {
    title: 'Priložte fotky alebo doklad',
    hint: (maxMegabytes: number) => `JPG, PNG alebo PDF · max. ${maxMegabytes} MB · nepovinné`,
  },
  consent: {
    prefix: 'Súhlasím so ',
    link: 'spracúvaním osobných údajov',
    suffix: ' na účel vybavenia mojej požiadavky.',
  },
  sent: {
    title: 'Ďakujeme, správu sme prijali',
    again: 'Napísať ďalšiu správu',
    home: 'Prejsť na hlavnú stránku',
  },
} as const;
